import { useCallback, useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Icon } from './JournalOverview';
import { useStillMotion } from './FlowMotion';
import './tool-motion.css';

export default function WorkspaceToast({ toast, onDismiss }) {
  const still = useStillMotion(), duration = toast.action ? 5200 : 2600;
  const [hovered, setHovered] = useState(false), [focused, setFocused] = useState(false), [hidden, setHidden] = useState(document.hidden);
  const remaining = useRef(duration), dismiss = useRef(onDismiss), root = useRef(null), origin = useRef(document.activeElement);
  dismiss.current = onDismiss;
  const paused = hovered || focused || hidden;
  useEffect(() => {
    const visibility = () => setHidden(document.hidden);
    document.addEventListener('visibilitychange', visibility);
    return () => document.removeEventListener('visibilitychange', visibility);
  }, []);
  useEffect(() => {
    if (paused) return;
    const start = Date.now(), timer = setTimeout(() => dismiss.current(toast.id), remaining.current);
    return () => { clearTimeout(timer); remaining.current = Math.max(0, remaining.current - (Date.now() - start)); };
  }, [paused, toast.id]);
  const close = useCallback(() => {
    if (root.current?.contains(document.activeElement) && origin.current?.isConnected) origin.current.focus({preventScroll:true});
    dismiss.current(toast.id);
  }, [toast.id]);
  return <motion.div ref={root} layout={!still} initial={still ? false : {opacity:0,y:12,scale:.97}} animate={{opacity:1,y:0,scale:1}} exit={{opacity:0,x:still?0:16,scale:still?1:.98}} transition={{duration:still?0:.24,ease:[.22,1,.36,1]}} className={`tl-workspace-toast tl-flow-toast ${toast.type === 'error' ? 'is-error' : ''} ${toast.action ? 'has-action' : ''}`} role={toast.type === 'error' ? 'alert' : 'status'} data-toast-paused={paused} style={{'--toast-duration':`${duration}ms`}} onPointerEnter={() => setHovered(true)} onPointerLeave={() => setHovered(false)} onFocusCapture={() => setFocused(true)} onBlurCapture={event => { if (!event.relatedTarget?.nodeType || !event.currentTarget.contains(event.relatedTarget)) setFocused(false); }}>
    <Icon name={toast.type === 'error' ? 'warning' : 'check-circle'} size={19}/><span>{toast.msg}</span>
    {toast.action && <button onClick={() => { toast.action.onClick(); close(); }}>{toast.action.label}</button>}
    <button type="button" className="tl-toast-dismiss" aria-label="Dismiss notification" onClick={close}><Icon name="close" size={14}/></button>
    <span className="tl-toast-lifetime" aria-hidden="true"/>
  </motion.div>;
}
